import { getBetDisplayLabel } from './betLabels';

const relationPrefixes = {
  rival: 'ライバルの',
  follow: 'フォロー中の',
  follower: 'フォロワーの',
};

const DEFAULT_MOBILE_MESSAGE_LIMIT = 24;

const buildBetDisplayMessage = (message, { isMobile, mobileMessageLimit }) => {
  const relation = message?.relation || 'other';
  const prefix = relationPrefixes[relation] || '';
  const name = message?.name || '';
  const selectionLabel = message?.selection_label || '選択肢';
  const selectionColor = message?.selection_color || '#fff';
  const selectionStyle = `color: ${selectionColor}; font-weight: 700;`;

  let subjectText;

  switch (relation) {
    case 'self':
      subjectText = 'あなたは ';
      break;
    case 'other':
      subjectText = `${name}さんが `;
      break;
    case 'rival':
    case 'follow':
    case 'follower':
      subjectText = `${prefix}${name}さんが `;
      break;
    default:
      subjectText = `${prefix}${name}さんが `;
      break;
  }

  const buildSegments = (label) => [
    { text: subjectText, style: null },
    { text: label, style: selectionStyle },
    { text: ' にベット!', style: null },
  ];

  const fullSegments = buildSegments(selectionLabel);
  const fullTextLength = fullSegments.reduce(
    (total, segment) => total + String(segment?.text ?? '').length,
    0,
  );

  // 名前はvalidation済みなので残し、モバイルで長い場合だけ回答本文を記号化する。
  if (isMobile && fullTextLength > mobileMessageLimit) {
    return buildSegments(getBetDisplayLabel(message?.selection));
  }

  return fullSegments;
};

export const normalizeRoomInformationMessages = (messages, isMobileOrOptions = false, options = {}) => {
  const config = typeof isMobileOrOptions === 'object' && isMobileOrOptions !== null
    ? {
      isMobile: Boolean(isMobileOrOptions.isMobile),
      mobileMessageLimit: isMobileOrOptions.mobileMessageLimit ?? DEFAULT_MOBILE_MESSAGE_LIMIT,
    }
    : {
      isMobile: Boolean(isMobileOrOptions),
      mobileMessageLimit: options?.mobileMessageLimit ?? DEFAULT_MOBILE_MESSAGE_LIMIT,
    };

  if (!Array.isArray(messages)) {
    return [];
  }

  return messages
    .map((message) => {
      if (!message || typeof message !== 'object' || Array.isArray(message)) {
        return { message, type: 'info' };
      }

      if (message.kind === 'bet') {
        return {
          ...message,
          message: buildBetDisplayMessage(message, config),
          type: message.type || message.level || 'info',
        };
      }

      return {
        ...message,
        message: message.text ?? '',
        type: message.type || message.level || 'info',
      };
    })
    .filter((message) => message.message !== '');
};
